import { UserContext } from "../../Contexts/UserContext";
import { ForumContext } from "../../Contexts/ForumContext";
import { PostContext } from "../../Contexts/PostContext";
import { EventContext } from "../../Contexts/EventContext";
import { NotificationContext } from "../../Contexts/NotificationContext";
import { SocketContext } from "../../Contexts/SocketContext";
import { NavLink } from "react-router-dom";
import { useContext, useRef } from "react";
import useOutsideAlerter from "../../Hooks/useOutsideAlerter";
import Toggle from "./Toggle";

function Dropdown({ showDropdown, setShowDropdown }) {
  const [user, setUser] = useContext(UserContext);
  const [forums, setForums] = useContext(ForumContext);
  const [posts, setPosts] = useContext(PostContext);
  const [events, setEvents] = useContext(EventContext);
  const [notifications, setNotifications] = useContext(NotificationContext);
  const [socket] = useContext(SocketContext);
  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef, setShowDropdown);

  function handleClick() {
    setShowDropdown(!showDropdown);
  }

  function logout() {
    handleClick();
    localStorage.removeItem("user");
    setUser(undefined);
    socket.current.emit("logout", user._id);
    setForums([]);
    setPosts([]);
    setEvents([]);
    setNotifications([]);
  }

  return (
    <div
      className="absolute bg-white shadow-base p-2 2xl:p-2.5 top-14 2xl:top-15 3xl:top-20 right-28 2xl:right-36 3xl:right-52 z-30 rounded dark:bg-darkSecondary"
      hidden={showDropdown ? false : true}
      ref={wrapperRef}
    >
      <ul>
        {/* profile */}
        <li
          className="p-2 2xl:p-2.5 text-sm 2xl:text-lg 3xl:p-3 3xl:text-xl dark:text-darkLight"
          onClick={handleClick}
        >
          <NavLink to="/profile">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="inline mr-2 fill-[#818181] dark:fill-darkLight w-4 2xl:w-5 3xl:w-6"
              viewBox="0 0 16 18"
            >
              <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z" />
              <path
                fillRule="evenodd"
                d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1z"
              />
            </svg>
            Profile
          </NavLink>
        </li>
        <hr />

        {/* settings */}
        {/* <li className="p-2 2xl:p-2.5 text-sm 2xl:text-lg 3xl:p-3 3xl:text-xl dark:text-darkLight" onClick={handleClick}>
          <NavLink to="/settings">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="inline mr-2 fill-[#818181] dark:fill-darkLight w-4 2xl:w-5 3xl:w-6"
              viewBox="0 0 16 16"
            >
              <path d="M8 4.754a3.246 3.246 0 1 0 0 6.492 3.246 3.246 0 0 0 0-6.492zM5.754 8a2.246 2.246 0 1 1 4.492 0 2.246 2.246 0 0 1-4.492 0z" />
              <path d="M9.796 1.343c-.527-1.79-3.065-1.79-3.592 0l-.094.319a.873.873 0 0 1-1.255.52l-.292-.16c-1.64-.892-3.433.902-2.54 2.541l.159.292a.873.873 0 0 1-.52 1.255l-.319.094c-1.79.527-1.79 3.065 0 3.592l.319.094a.873.873 0 0 1 .52 1.255l-.16.292c-.892 1.64.901 3.434 2.541 2.54l.292-.159a.873.873 0 0 1 1.255.52l.094.319c.527 1.79 3.065 1.79 3.592 0l.094-.319a.873.873 0 0 1 1.255-.52l.292.16c1.64.893 3.434-.902 2.54-2.541l-.159-.292a.873.873 0 0 1 .52-1.255l.319-.094c1.79-.527 1.79-3.065 0-3.592l-.319-.094a.873.873 0 0 1-.52-1.255l.16-.292c.893-1.64-.902-3.433-2.541-2.54l-.292.159a.873.873 0 0 1-1.255-.52l-.094-.319zm-2.633.283c.246-.835 1.428-.835 1.674 0l.094.319a1.873 1.873 0 0 0 2.693 1.115l.291-.16c.764-.415 1.6.42 1.184 1.185l-.159.292a1.873 1.873 0 0 0 1.116 2.692l.318.094c.835.246.835 1.428 0 1.674l-.319.094a1.873 1.873 0 0 0-1.115 2.693l.16.291c.415.764-.42 1.6-1.185 1.184l-.291-.159a1.873 1.873 0 0 0-2.693 1.116l-.094.318c-.246.835-1.428.835-1.674 0l-.094-.319a1.873 1.873 0 0 0-2.692-1.115l-.292.16c-.764.415-1.6-.42-1.184-1.185l.159-.291A1.873 1.873 0 0 0 1.945 8.93l-.319-.094c-.835-.246-.835-1.428 0-1.674l.319-.094A1.873 1.873 0 0 0 3.06 4.377l-.16-.292c-.415-.764.42-1.6 1.185-1.184l.292.159a1.873 1.873 0 0 0 2.692-1.115l.094-.319z" />
            </svg>
            Settings{" "}
          </NavLink>
        </li>
        <hr /> */}

        {/* Dark mode */}
        <Toggle />
        <hr />

        {/* logout */}
        <li
          className="p-2 2xl:p-2.5 text-sm 2xl:text-lg 3xl:p-3 3xl:text-xl dark:text-darkLight"
          onClick={logout}
        >
          <NavLink to="/">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="inline mr-2 fill-[#818181] dark:fill-darkLight w-4 2xl:w-5 3xl:w-6"
              viewBox="0 0 16 16"
            >
              <path
                fillRule="evenodd"
                d="M10 12.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 1 0v-2A1.5 1.5 0 0 0 9.5 2h-8A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-2a.5.5 0 0 0-1 0v2z"
              />
              <path
                fillRule="evenodd"
                d="M15.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L14.293 7.5H5.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3z"
              />
            </svg>
            Log out
          </NavLink>
        </li>
      </ul>
    </div>
  );
}

export default Dropdown;
